import React, { useEffect } from "react";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  useSidebar,
} from "../ui/sidebar";
import Link from "next/link";
import { navData } from "./constant";
import { useRouter } from "next/router";
import { useAuth } from "@/hooks/useAuth";
import { useDispatch } from "react-redux";
import { setPreviewOpen } from "@/store/assistance";
import { useSelector } from "react-redux";
import { isIframe } from "@/utils/helper";

export default function MainNav() {
  const router = useRouter();
  const { open } = useSidebar();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const activePath = router.pathname.split("/")[1];

  const isPreviewOpen = useSelector((state) => state.assistant.preview.open);
  const isBrandSkipped = useSelector((s) => s.tour.isBrandSkipped);

  // When user navigates to difference page when the preview panel is open, close it.
  useEffect(() => {
    if (isIframe()) return;

    if (activePath == "ai-mode" && isPreviewOpen) {
      dispatch(setPreviewOpen(true));
    } else {
      dispatch(setPreviewOpen(false));
    }
  }, [activePath]);

  return (
    <SidebarGroup>
      <SidebarGroupLabel className="text-[1.25rem] mb-2 -translate-x-1 px-4">
        Applications
      </SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          {navData.map((item) => {
            const isAllowed = item?.allowedRole.includes(
              user?.attributes?.role_numeric,
            );

            if (!isAllowed) return;

            return (
              <Link
                href={item.path}
                className={`text-[1.4rem] transition-all duration-300 rounded-xl py-3 flex items-center gap-6 hover:bg-gray-200 hover:text-accent-foreground dark:hover:bg-accent cursor-pointer px-4 relative${
                  activePath == item.path.split("/")?.[1]
                    ? "bg-gray-200  font-[500] dark:bg-accent"
                    : ""
                }`}
                key={item.title}
                title={item.title}
              >
                <item.icon style={{ width: 18, height: 18 }} />
                {open && item.title}
                {(item.title == "Brand Assets" && isBrandSkipped) && (
                  <div
                    title="Brand Information is required."
                    className="h-4 w-4 rounded-full  bg-blue-700 "
                  />
                )}
              </Link>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}

{
  /* <Badge
                   variant={'outline'}
                   className={'text-[1.1rem] px-4 py-4 rounded-full absolute  right-8 '}
                   >Not Provided</Badge> */
}
